

















































import { Component, Prop, Watch, Vue } from 'vue-property-decorator'

@Component
export default class ErrorInfo extends Vue {
  @Prop() private alertText!: string
  @Prop() private alertTitle!: string

  private displayTitle: string = '正しく入力されていない項目があります。メッセージをご確認の上、もう一度ご入力ください。'

  @Watch('alertTitle')
  onIdChange (title: string) {
    if (title === '' && this.alertText === '') {
      this.displayTitle = '正しく入力されていない項目があります。メッセージをご確認の上、もう一度ご入力ください。'
    } else {
      this.displayTitle = title
    }
  }
}
